import React from 'react';

export const AlertRedIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M11.953 2C6.465 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514
         22 22 17.514 22 12C22 6.486 17.493 2 11.953 2ZM13 17H11V15H13V17ZM13
         13H11V7H13V13Z"
      fill="#E11900"
    />
  </svg>
);
